/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import Body from '../Cell/Body';
import hasProperty from 'lib/hasProperty';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

type Chart = {
  name: string,
  source: string,
  component: any,
  visible?: any,
};

/**
 * Dispatches a `section-change` custom event.
 * @param {boolean} inView
 * @param {!Element} name
 */
function fire(inView, name) {
  const evt = new CustomEvent('section-change', { detail: { inView, name } });
  document.dispatchEvent(evt);
}

const Section = ({ v, section }) => {
  const [ref, inView, entry] = useInView({
    threshold: 0.1,
    container: document.body,
  });
  useEffect(() => {
    entry && entry.target && fire(inView, section);
  }, [inView]);

  return (
    <Body
      ref={ref}
      styles={'padding: 0;'}
      innerStyles={'padding-top: 0; padding-right: 1rem; min-height: 200px;'}
      preface={
        <div>
          <h1 css={{ fontSize: '2rem', fontWeight: 'bold' }}>{v.name}</h1>
          <h2>
            <b>Source:</b> {v.source}
          </h2>
        </div>
      }
    >
      {jsx(v.component, { name: v.name, section, source: v.source })}
    </Body>
  );
};

export default ({ charts, name }: { charts: Chart[], name: string }) => {
  return charts
    .filter(v => (hasProperty(v, 'visible') ? v.visible : true))
    .map<React$Node>((v, i) => <Section v={v} section={name} key={i} />);
};
